export default "__VITE_ASSET__ef3511de__"